module.exports = __webpack_public_path__ + "static/media/assignPadActionIcon.fafebabd.svg";